var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['core', 'jquery', 'underscore', 'backbone', 'app-common/component/baseView', 'app-common/component/api-call', 'common/component/date-formatter', 'app-common/template/notes/note.htm', 'common/lib/jquery.hotkeys'], function(core, $, _, Backbone, BaseView, apiCall, dateFormatter, noteTemplate) {
  var NotesItemView;
  return NotesItemView = (function(_super) {

    __extends(NotesItemView, _super);

    NotesItemView.prototype.template = function(data) {
      return _.template(noteTemplate, data);
    };

    NotesItemView.prototype.tagName = 'li';

    NotesItemView.prototype.className = 'bl-note comments-display__message';

    NotesItemView.prototype.editClassName = 'editing comments-display--is-editing';

    NotesItemView.prototype.events = {
      'click .bl-note__edit-open-btn': 'openNoteEdit',
      'click .bl-note__edit-close-btn': 'closeNoteEdit',
      'click .bl-note__save-btn': 'handleUpdateNote',
      'click .bl-note__delete-btn': 'handleDeleteNote',
      'click .bl-note__flag': 'handleToggleFlag'
    };

    NotesItemView.prototype.defaultAvatar = 'https://secure.gravatar.com/avatar/00000000000000000000000000000000?d=mm&f=y';

    NotesItemView.prototype.$body = function() {
      return this.$('.bl-note__body');
    };

    NotesItemView.prototype.$footer = function() {
      return this.$('.bl-note__footer');
    };

    function NotesItemView(model) {
      NotesItemView.__super__.constructor.apply(this, arguments);
      this.model = model;
      this.bindEvents();
      this.render();
    }

    NotesItemView.prototype.bindEvents = function() {
      return this.listenTo(this.model, 'change', this.render);
    };

    NotesItemView.prototype.bindHotkeys = function() {
      var _ref, _ref1,
        _this = this;
      return $(this.el).on('keydown', (_ref1 = this.$body()) != null ? _ref1.selector : void 0, 'ctrl+return', function(e) {
        e.preventDefault();
        return _this.handleUpdateNote(e);
      }).on('keydown', (_ref = this.$body()) != null ? _ref.selector : void 0, function(e) {
        return e.stopPropagation();
      });
    };

    NotesItemView.prototype.toggleEditableBody = function(isEditable, $body) {
      if ($body == null) {
        $body = this.$body();
      }
      $body.prop('contenteditable', isEditable);
      return isEditable && $body.focus();
    };

    NotesItemView.prototype.openNoteEdit = function() {
      this.toggleEditableBody(true);
      return this.$footer().addClass(this.editClassName);
    };

    NotesItemView.prototype.closeNoteEdit = function() {
      this.toggleEditableBody(false);
      return this.$footer().removeClass(this.editClassName);
    };

    NotesItemView.prototype.handleUpdateNote = function() {
      var body;
      body = this.$body().text();
      this.model.set('body', this.sanitize(body));
      return this.model.collection.trigger('modelUpdate');
    };

    NotesItemView.prototype.handleDeleteNote = function() {
      this.collection.remove(this.model);
      return this.destroy();
    };

    NotesItemView.prototype.handleToggleFlag = function() {
      this.model.set('flagged', !this.model.get('flagged'));
      return this.model.collection.trigger('modelUpdate');
    };

    NotesItemView.prototype.getUsername = function(note) {
      var person, _ref;
      if (note.userFirstName && note.userLastName) {
        return note.userFirstName + " " + note.userLastName;
      }
      if (parseInt(note.userId) === 0) {
        return 'Legacy Note';
      }
      person = (_ref = this.model.getPersonModel()) != null ? _ref.toJSON() : void 0;
      if (person != null ? person.fullName : void 0) {
        return person.fullName;
      }
      return userId;
    };

    NotesItemView.prototype.render = function() {
      var defaultAvatar, note;
      defaultAvatar = this.defaultAvatar;
      note = this.model.toJSON();
      this.$el.toggleClass('flagged', this.model.get('flagged'));
      this.$el.html(this.template({
        timeAgo: dateFormatter.timeAgo,
        note: note,
        username: this.getUsername(note),
        defaultAvatar: defaultAvatar
      }));
      this.bindHotkeys();
      return this.$el;
    };

    return NotesItemView;

  })(BaseView);
});
